import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const GeoPoint: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[28px] h-[28px]', className)}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 4.66732C16.5666 4.66732 18.6666 6.76732 18.6666 9.33398C18.6666 11.784 16.2166 15.7507 14 18.5506C11.7833 15.634 9.33329 11.784 9.33329 9.33398C9.33329 6.76732 11.4333 4.66732 14 4.66732ZM14 2.33398C10.15 2.33398 6.99996 5.48398 6.99996 9.33398C6.99996 14.584 14 22.1673 14 22.1673C14 22.1673 21 14.4673 21 9.33398C21 5.48398 17.85 2.33398 14 2.33398ZM14 7.00065C12.7166 7.00065 11.6666 8.05065 11.6666 9.33398C11.6666 10.6173 12.7166 11.6673 14 11.6673C15.2833 11.6673 16.3333 10.6173 16.3333 9.33398C16.3333 8.05065 15.2833 7.00065 14 7.00065ZM23.3333 22.1673C23.3333 24.734 19.1333 26.834 14 26.834C8.86663 26.834 4.66663 24.734 4.66663 22.1673C4.66663 20.6507 6.06663 19.3673 8.28329 18.434L8.98329 19.484C7.81663 20.0673 6.99996 20.7673 6.99996 21.584C6.99996 23.2173 10.15 24.5007 14 24.5007C17.85 24.5007 21 23.2173 21 21.584C21 20.7673 20.1833 20.0673 18.9 19.484L19.6 18.434C21.9333 19.3673 23.3333 20.6507 23.3333 22.1673Z"
      fill="currentColor"
    />
  </svg>
);

export default GeoPoint;
